<template>
  <div class="download-items">
    <h2 class="download-items__heading">
      Digital resources
    </h2>

    <div v-if="loading"
         class="download-items__loading-container">
      <div class="download-items__loading-content">
        <h6>Loading digital resources</h6>
        <font-awesome-icon icon="spinner"
                           class="icon"
                           size="lg"
                           spin></font-awesome-icon>
      </div>
    </div>

    <div v-else
         class="row no-padding">
      <template v-if="downloads && downloads.length > 0">
        <div v-for="( item, index ) in downloads"
             :key="index"
             class="col-lg-6 col-12 no-padding"
             style="display: flex">
          <download-item :item="item">
          </download-item>
        </div>
      </template>
      <template v-else>
        <div class="download-items__empty">
          <p>No downloads found.</p>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { loadDownloads } from "~/Scripts/resources/downloadsResource";
import DownloadItem from "~/Components/Downloads/DownloadItem.vue";

export default {
  name: "DigitalResources",
  components: {
    DownloadItem
  },
  data () {
    return {
      downloads: [],
      imageUrl: "",
      description: "The english team offers up-to-date guidance and support to enable schools to develop and enhance their understanding of how children learn and the most effective ways to support learning. The work of the advisers is underpinned by current research and the teams are actively involved in research projects and publication.",
      loading: false
    };
  },
  mounted () {
    this.loading = true;

    loadDownloads()
      .then( ( result ) => {
        if ( result && result.data ) {
          this.downloads = result.data;
        }
      } ).catch( ( error ) => {
        console.log( "error loading download items", error );
        throw error;
      } ).finally( () => {
        this.loading = false;
      } );
  }
};
</script>

<style lang="less" scoped>
.download-items {
  position: relative;

  &__heading {
    letter-spacing: normal;
    font-weight: bold;
    font-size: 16pt;
    margin-top: 0;
    margin-bottom: 30px;
  }

  &__loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__loading-content {
    display: flex;
    justify-content: center;
    align-items: center;

    h6 {
      margin-bottom: 0;
    }

    .icon {
      margin: 10px
    }
  }

  &__empty {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    width: 100%;
  }

  .no-padding {
    margin: 0 !important;
    padding: 0 !important;
  }
}
</style>
